import { onBeforeUnmount } from "vue";
import type { Ref } from "vue";
import { onBeforeRouteLeave } from "vue-router/composables";
import i18n from "@/i18n";

export function useUnsavedDataGuard(hasUnsavedData: Ref<boolean>) {
  function confirmLeave() {
    return window.confirm(
      i18n.t(
        "Imate nespremljenih promjena. Želite li stvarno odustati od njih?"
      ) as string
    );
  }

  function confirmStayInDirtyForm() {
    return hasUnsavedData.value && !confirmLeave();
  }

  function beforeWindowUnload(event: BeforeUnloadEvent) {
    if (confirmStayInDirtyForm()) {
      event.preventDefault();
    }
  }

  window.addEventListener("beforeunload", beforeWindowUnload);

  onBeforeRouteLeave((_to, _from, next) => {
    if (!hasUnsavedData.value) {
      next();
      return;
    }

    if (confirmLeave()) {
      next();
    } else {
      next(false);
    }
  });

  onBeforeUnmount(() => {
    window.removeEventListener("beforeunload", beforeWindowUnload);
  });

  return { confirmLeave, confirmStayInDirtyForm };
}
